import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import { PROGRESS_STATES } from '../../../../constants/enums'

export default class TasksActivitiesTableSingle extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    isAssessorWelcomeEmailEnabled: PropTypes.bool.isRequired,
    isAssessorManagementEnabled: PropTypes.bool.isRequired,
    validationData: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired
  }

  defaultProps = {
    isAssessorWelcomeEmailEnabled: false
  }

  state = {
    activityIdApprove: null,
    activityState: null,
    activityIdReturn: null
  }

  key = uuid.v1()

  handleApproveModal = data => {
    const activityIdApprove = get(data, 'id')

    const activityState = get(data, 'activityState.value')

    this.setState(
      {
        activityIdApprove,
        activityState
      },
      () => {
        this.props.modal(`modal-approve-activity-${this.key}`)
      }
    )
  }

  handleReturnModal = activityIdReturn => {
    this.setState(
      {
        activityIdReturn
      },
      () => {
        this.props.modal(`modal-return-activity-${this.key}`)
      }
    )
  }

  render() {
    const {
      data,
      approveModal,
      returnModal,
      isAssessorWelcomeEmailEnabled,
      isAssessorManagementEnabled,
      codeLists,
      validationData } = this.props

      const showReasons = get(data, 'activityState.value') === PROGRESS_STATES.activityApproval.id

    return (
      <div>
        <Table ths={tasksLayout.activityApprovalSingleTableHeaders}>
          <Data>
            <tr>
              <td>{get(data, 'activityCategory.parent.translatedName')}</td>
              <td>{get(data, 'activityCategory.translatedName')}</td>
              <td>{get(data, 'aim')}</td>
              <td className="text--right">
                <ButtonGroup right>
                  <Button
                    type="button"
                    onClick={() => this.handleApproveModal(data)}
                    intlKey={isAssessorManagementEnabled ? 'button.authorize' : 'button.approve'}
                    small
                  >
                    {isAssessorManagementEnabled ? 'Authorize' : 'Approve'}
                  </Button>
                  <Button
                    type="button"
                    onClick={() => this.handleReturnModal(get(data, 'id'))}
                    intlKey="button.revise"
                    secondary
                    small
                  >
                    Revise
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <Modal id={`modal-approve-activity-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.activityIdApprove}
            modal={this.props.modal}
            isAssessorWelcomeEmailEnabled={isAssessorWelcomeEmailEnabled}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            activityState={this.state.activityState}
            isActivityTask={true}
            validationData={validationData}
          />
        </Modal>
        <Modal id={`modal-return-activity-${this.key}`} customActions enableOverflow>
          <TaskReturn
            returnTask={returnModal}
            id={this.state.activityIdReturn}
            modal={this.props.modal}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
            showReasons={showReasons}
          />
        </Modal>
      </div>
    )
  }
}
